<template>
  <painter></painter>
</template>

<script>
import Painter from './components/Painter.vue'

export default {
  name: 'App',
  components: {
    Painter
  }
}
</script>
<style>
  #app {
    height: 100%;
  }
</style>